// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "VideosSection-module--wrapper--8Luo3";
export var spacer = "VideosSection-module--spacer--aSOJx";
export var videoWrapper = "VideosSection-module--videoWrapper--bqIYP";